//import React, { useState } from "react";
import React from "react";
const UserSearchCard = ({

    tenants,

    locations,

    departments,

    filters,

    setFilters,

    onSearch

}) => {

    

    const handleChange = (e) => {

        setFilters({

            ...filters,

            [e.target.name]: e.target.value

        });

    };

    const handleSearch = () => {

         onSearch(filters);

    };

    return (

        <div className="card shadow-sm mb-3">

            <div className="card-body">

                <div className="row g-3 align-items-end">

                    {/* Tenant */}

                    <div className="col-lg-2">

                        <label className="form-label">

                            Tenant

                        </label>

                        <select
                            className="form-select"
                            name="tenant_id"
                            value={filters.tenant_id}
                            onChange={(e) =>
                                setFilters({

                                    ...filters,

                                    tenant_id: e.target.value,

                                    location_id: "",

                                    department_id: ""

                                })
                            }
                        >

                            <option value="">

                                All Tenants

                            </option>

                            {

                                tenants.map(tenant => (

                                    <option
                                        key={tenant.id}
                                        value={tenant.id}
                                    >

                                        {tenant.name}

                                    </option>

                                ))

                            }

                        </select>

                    </div>

                    {/* Location */}

                    <div className="col-lg-2">

                        <label className="form-label">

                            Location

                        </label>

                        <select
                            className="form-select"
                            name="location_id"
                            value={filters.location_id}
                            onChange={(e) =>
                                setFilters({

                                    ...filters,

                                    location_id: e.target.value,

                                    department_id: ""

                                })
                            }
                        >

                            <option value="">

                                All Locations

                            </option>

                            {

                                locations.map(location => (

                                    <option
                                        key={location.id}
                                        value={location.id}
                                    >

                                        {location.name}

                                    </option>

                                ))

                            }

                        </select>

                    </div>

                    {/* Department */}

                    <div className="col-lg-2">

                        <label className="form-label">

                            Department

                        </label>

                        <select
                            className="form-select"
                            name="department_id"
                            value={filters.department_id}
                            onChange={(e) =>
                                setFilters({

                                    ...filters,

                                    department_id: e.target.value

                                })
                            }
                        >

                            <option value="">

                                All Departments

                            </option>

                            {

                                departments.map(department => (

                                    <option
                                        key={department.id}
                                        value={department.id}
                                    >

                                        {department.name}

                                    </option>

                                ))

                            }

                        </select>

                    </div>

                    {/* Search */}

                    <div className="col-lg-4">

                        <label className="form-label">

                            Search User

                        </label>

                        <input
                            className="form-control"
                            name="search"
                            value={filters.search}
                            onChange={handleChange}
                            placeholder="Username / Email / Mobile"
                        />

                    </div>

                    {/* Button */}

                    <div className="col-lg-2">

                        <button
                            className="btn btn-primary w-100"
                            style={{ height: "38px" }}
                            onClick={handleSearch}
                        >

                            Search

                        </button>

                    </div>

                </div>

            </div>

        </div>

    );

};

export default UserSearchCard;